import { PARTNER_INSTITUTIONS } from './partner-institutions.constants';

export const ALL = 'All';

export const allSections = [
  { name: 'Opportunity', role: 'org-admin' },
  // { name: 'Academic Staff', role: 'academic-staff-admin' },
  // { name: 'Administrative Staff', role: 'administrative-staff-admin' },
  // { name: 'Non-University Stakeholder', role: 'non-university-stakeholder-admin' },
  { name: 'Super Admin', role: 'super-admin' }
];

export const adminRoles = [
  // 'student-admin',
  // 'academic-staff-admin',
  // 'administrative-staff-admin',
  // 'non-university-stakeholder-admin',
  'org-admin',
  'super-admin',
];

export const availableOpportunityStatus = [
  { value: 'active', name: 'Active', isFilter: true },
  { value: 'pending', name: 'Pending', isFilter: true },
  { value: 'declined', name: 'Declined', isFilter: true }
];

export const availableFormats = [
  { value: 'pdf', name: 'PDF', isFilter: true },
  { value: 'png', name: 'PNG', isFilter: true },
  { value: 'jpg', name: 'JPG', isFilter: true },
  { value: 'docx', name: 'DOCX', isFilter: true },
  { value: 'pptx', name: 'PPTX', isFilter: true },
  { value: 'any', name: 'ANY', isFilter: true },

];

export const availableDocuments = [
  { value: 'motivation-letter', name: 'Motivational Letter', isFilter: true },
  { value: 'recommendation-letter', name: 'Recommendation Letter', isFilter: true },
  { value: 'language-certificate', name: 'Language Certificate', isFilter: true },
  { value: 'portfolio', name: 'Portfolio', isFilter: true },
  { value: 'publications', name: 'Publications or Research Papers', isFilter: true },
  { value: 'study-certificate', name: 'Study Certificate or Diploma', isFilter: true },
  { value: 'research-plan', name: 'Research or Project Plan', isFilter: true },
  { value: 'work-experience-proof', name: 'Proof of Work Experience', isFilter: true },
  { value: 'photo', name: 'Photo', isFilter: true },
  { value: 'other', name: "Other", isFilter: true}
];

export const availableLanguages = [
  { value: 'en', name: 'English', flag: 'gb', isFilter: true },
  { value: 'fr', name: 'French', flag: 'fr', isFilter: true },
  { value: 'de', name: 'German', flag: 'de', isFilter: true },
  { value: 'hu', name: 'Hungarian', flag: 'hu', isFilter: true },
  { value: 'ie', name: 'Irish', flag: 'ie', isFilter: true },
  { value: 'it', name: 'Italian', flag: 'it', isFilter: true },
  { value: 'no', name: 'Norwegian', flag: 'no', isFilter: true },
  { value: 'pl', name: 'Polish', flag: 'pl', isFilter: true },
  { value: 'pt', name: 'Portuguese', flag: 'pt', isFilter: true },
  { value: 'rs', name: 'Serbian', flag: 'rs', isFilter: true },
  { value: 'es', name: 'Spanish', flag: 'es', isFilter: true },
  { value: 'se', name: 'Swedish', flag: 'se', isFilter: true },
];

export const availableCountries = [
  { value: 'france', name: 'France', flag: 'fr', isFilter: true },
  { value: 'germany', name: 'Germany', flag: 'de', isFilter: true },
  { value: 'hungary', name: 'Hungary', flag: 'hu', isFilter: true },
  { value: 'portugal', name: 'Portugal', flag: 'pt', isFilter: true },
  { value: 'serbia', name: 'Serbia', flag: 'rs', isFilter: true },
  { value: 'spain', name: 'Spain', flag: 'es', isFilter: true },
  { value: 'norway', name: 'Norway', flag: 'no', isFilter: true },
  { value: 'sweden', name: 'Sweden', flag: 'se', isFilter: true },
  { value: 'united-kingdom', name: 'United Kingdom', flag: 'gb', isFilter: true },
  { value: 'netherlands', name: 'Netherlands', flag: 'nl', isFilter: true },
  { value: 'austria', name: 'Austria', flag: 'at', isFilter: true },
  { value: 'brazil', name: 'Brazil', flag: 'br', isFilter: true },
  { value: 'ireland', name: 'Ireland', flag: 'ie', isFilter: true },
  { value: 'italy', name: 'Italy', flag: 'it', isFilter: true },
  { value: 'poland', name: 'Poland', flag: 'pl', isFilter: true },
  { value: 'south-africa', name: 'South Africa', flag: 'za', isFilter: true },
];

export const availableActions = [
  { value: 'joint-course', name: 'Joint activities/courses/workshops', isFilter: true },
  { value: 'lecture', name: 'Guest lectures/Teaching opportunities', isFilter: true },
  { value: 'conference', name: 'Conference speakers', isFilter: true },
  { value: 'eu-project-call', name: 'EU/International project calls', isFilter: true },
  { value: 'research-stay', name: 'Research collaborations', isFilter: true },
  { value: 'innovate', name: 'Innovation collaborations', isFilter: true },
  { value: 'job-shadowing', name: 'Job shadowing', isFilter: true },
  { value: 'internship', name: 'Internships', isFilter: true },
  { value: 'phd', name: 'PhD positions', isFilter: true },
  { value: 'training-opportunity', name: 'Training opportunities', isFilter: true },
  { value: 'other', name: 'Other', isOther: true }
];

export const originalPartnerAffiliations = [
  { value: 'universite-paris-saclay', name: 'Université Paris-Saclay', isFilter: true, logo: 'upsaclay_logo.png' },
  { value: 'lund-university', name: 'Lund University', isFilter: true, logo: 'lunds_logo.png' },
  { value: 'ludwig-maximilians-universitat-munchen', name: 'Ludwig-Maximilians-Universität München', isFilter: true, logo: 'lmu_logo.png' },
  { value: 'universidade-do-porto', name: 'Universidade do Porto', isFilter: true, logo: 'porto_logo.png' },
  { value: 'university-of-szeged', name: 'University of Szeged', isFilter: true, logo: 'szte_logo.jpg' },
  { value: 'university-of-alcala', name: 'University of Alcalá', isFilter: true, logo: 'alcala_logo.jpg' },
  { value: 'universitat-hamburg', name: 'Universität Hamburg', isFilter: true, logo: 'hamburg_logo.png' },
  { value: 'university-of-novi-sad', name: 'University of Novi Sad', isFilter: true, logo: 'novisad_logo.jpg' },
  { value: 'uit-the-arctic-university-of-norway', name: 'UiT The Arctic University of Norway', isFilter: true, logo: 'uit_logo.png' },
];

export const availableAffiliations = [
  ...originalPartnerAffiliations,
  ...PARTNER_INSTITUTIONS.map(({ value, name, logo }) => ({ value, name, isFilter: true, logo })),
  { value: 'eugloh-secretariat', name: 'EUGLOH Secretariat', isFilter: true, logo: 'EUGLOH_logo.png' },
  { value: 'other', name: 'Other', isFilter: true, logo: '' },
];

// Retained for existing records until users and opportunities are migrated.
export const legacyAffiliations = [
  { value: 'eugloh-core-partner', name: 'EUGLOH Core partner', isFilter: true, logo: 'EUGLOH_logo.png' },
  { value: 'eugloh-anchor-partner', name: 'EUGLOH Anchor partner', isFilter: true, logo: 'EUGLOH_logo.png' }
];

export const knownAffiliations = [...availableAffiliations, ...legacyAffiliations];

export const predefinedAffiliationValues = knownAffiliations
  .filter(affiliation => affiliation.value !== 'other')
  .map(affiliation => affiliation.value);

export function getAffiliationName(value: string): string {
  return knownAffiliations.find(affiliation => affiliation.value === value)?.name || value;
}

export const availableSdgs = [
  { value: 'good-health-and-well-being', name: 'Good Health and Well-being', isFilter: true },
  { value: 'affordable-and-clean-energy', name: 'Affordable and Clean Energy', isFilter: true },
  { value: 'reduced-inequalities', name: 'Reduced Inequalities', isFilter: true },
  { value: 'sustainable-cities-and-communities', name: 'Sustainable Cities and Communities', isFilter: true },
  { value: 'clean-water-and-sanitation', name: 'Clean Water and Sanitation', isFilter: true },
  { value: 'responsible-consumption-and-production', name: 'Responsible Consumption and Production', isFilter: true },
  { value: 'climate-action', name: 'Climate Action', isFilter: true },
  { value: 'life-on-land', name: 'Life on Land', isFilter: true },
  { value: 'other', name: 'Other', isOther: true }
];

export const availableFieldsOfScience = [
  { value: 'interdisciplinary', name: 'Interdisciplinary', isFilter: true },
  { value: 'Education', name: 'Education', isFilter: true },
  { value: 'Arts-and-humanities', name: 'Arts and humanities', isFilter: true },
  { value: 'Social-sciences', name: 'Social sciences, journalism and information', isFilter: true },
  { value: 'Business-administration-and-law', name: 'Business, administration and Law', isFilter: true },
  { value: 'Natural-sciences', name: 'Natural sciences, mathematics and statistics', isFilter: true },
  { value: 'Information-and-communication-technologies', name: 'Information and Communication Technologies', isFilter: true },
  { value: 'Engineering-manufacturing-and-construction', name: 'Engineering, manufacturing and construction', isFilter: true },
  { value: 'Agriculture-forestry-fisheries-and-veterinary', name: 'Agriculture, forestry, fisheries and veterinary', isFilter: true },
  { value: 'Health-and-welfare', name: 'Health and welfare', isFilter: true },
  { value: 'Services', name: 'Services', isFilter: true },
  { value: 'other', name: 'Other', isOther: true }
];

export const availableOpportunityType = [
  { value: 'looking-for', name: 'Looking For', isFilter: true },
  { value: 'offer', name: 'Offering', isFilter: true },
];

export const availableWorkPackage = [
  { value: 'student', name: 'Student', isFilter: true },
  { value: 'academic-staff', name: 'Academic Staff', isFilter: true },
  { value: 'administrative-staff', name: 'Administrative Staff', isFilter: true },
  { value: 'non-university-stakeholder', name: 'Non-University Stakeholder', isFilter: true }
];

export const availableExpertiseAreas = [
  { value: '3d-modeling', name: '3D Modeling', isFilter: true },
  { value: 'adult-education', name: 'Adult Education', isFilter: true },
  { value: 'aerospace-engineering', name: 'Aerospace Engineering', isFilter: true },
  { value: 'agile-methodologies', name: 'Agile Methodologies', isFilter: true },
  { value: 'animation', name: 'Animation', isFilter: true },
  { value: 'architecture', name: 'Architecture', isFilter: true },
  { value: 'artificial-intelligence', name: 'Artificial Intelligence', isFilter: true },
  { value: 'audio-engineering', name: 'Audio Engineering', isFilter: true },
  { value: 'augmented-reality', name: 'Augmented Reality', isFilter: true },
  { value: 'big-data', name: 'Big Data', isFilter: true },
  { value: 'biotechnology', name: 'Biotechnology', isFilter: true },
  { value: 'blockchain-technology', name: 'Blockchain Technology', isFilter: true },
  { value: 'business-analysis', name: 'Business Analysis', isFilter: true },
  { value: 'change-management', name: 'Change Management', isFilter: true },
  { value: 'chemical-engineering', name: 'Chemical Engineering', isFilter: true },
  { value: 'civil-engineering', name: 'Civil Engineering', isFilter: true },
  { value: 'climate-change-mitigation', name: 'Climate Change Mitigation', isFilter: true },
  { value: 'cloud-computing', name: 'Cloud Computing', isFilter: true },
  { value: 'cognitive-science', name: 'Cognitive Science', isFilter: true },
  { value: 'computer-vision', name: 'Computer Vision', isFilter: true },
  { value: 'conflict-resolution', name: 'Conflict Resolution', isFilter: true },
  { value: 'content-strategy', name: 'Content Strategy', isFilter: true },
  { value: 'corporate-law', name: 'Corporate Law', isFilter: true },
  { value: 'creative-writing', name: 'Creative Writing', isFilter: true },
  { value: 'curriculum-development', name: 'Curriculum Development', isFilter: true },
  { value: 'customer-experience', name: 'Customer Experience', isFilter: true },
  { value: 'cybersecurity', name: 'Cybersecurity', isFilter: true },
  { value: 'data-analytics', name: 'Data Analytics', isFilter: true },
  { value: 'data-science', name: 'Data Science', isFilter: true },
  { value: 'database-management', name: 'Database Management', isFilter: true },
  { value: 'devops', name: 'DevOps', isFilter: true },
  { value: 'digital-marketing', name: 'Digital Marketing', isFilter: true },
  { value: 'diplomacy', name: 'Diplomacy', isFilter: true },
  { value: 'e-learning', name: 'E-learning', isFilter: true },
  { value: 'early-childhood-education', name: 'Early Childhood Education', isFilter: true },
  { value: 'education-technology', name: 'Education Technology', isFilter: true },
  { value: 'electrical-engineering', name: 'Electrical Engineering', isFilter: true },
  { value: 'environmental-science', name: 'Environmental Science', isFilter: true },
  { value: 'financial-planning', name: 'Financial Planning', isFilter: true },
  { value: 'fitness-training', name: 'Fitness Training', isFilter: true },
  { value: 'game-development', name: 'Game Development', isFilter: true },
  { value: 'genetic-engineering', name: 'Genetic Engineering', isFilter: true },
  { value: 'graphic-design', name: 'Graphic Design', isFilter: true },
  { value: 'human-resources', name: 'Human Resources', isFilter: true },
  { value: 'instructional-design', name: 'Instructional Design', isFilter: true },
  { value: 'intellectual-property-law', name: 'Intellectual Property Law', isFilter: true },
  { value: 'international-relations', name: 'International Relations', isFilter: true },
  { value: 'internet-of-things', name: 'Internet of Things (IoT)', isFilter: true },
  { value: 'interpretation', name: 'Interpretation', isFilter: true },
  { value: 'journalism', name: 'Journalism', isFilter: true },
  { value: 'leadership-development', name: 'Leadership Development', isFilter: true },
  { value: 'legal-research', name: 'Legal Research', isFilter: true },
  { value: 'machine-learning', name: 'Machine Learning', isFilter: true },
  { value: 'market-research', name: 'Market Research', isFilter: true },
  { value: 'mechanical-engineering', name: 'Mechanical Engineering', isFilter: true },
  { value: 'medicine', name: 'Medicine', isFilter: true },
  { value: 'mobile-app-development', name: 'Mobile App Development', isFilter: true },
  { value: 'music-production', name: 'Music Production', isFilter: true },
  { value: 'nanotechnology', name: 'Nanotechnology', isFilter: true },
  { value: 'natural-language-processing', name: 'Natural Language Processing', isFilter: true },
  { value: 'negotiation', name: 'Negotiation', isFilter: true },
  { value: 'network-engineering', name: 'Network Engineering', isFilter: true },
  { value: 'neuroscience', name: 'Neuroscience', isFilter: true },
  { value: 'nutrition', name: 'Nutrition', isFilter: true },
  { value: 'occupational-therapy', name: 'Occupational Therapy', isFilter: true },
  { value: 'pharmacology', name: 'Pharmacology', isFilter: true },
  { value: 'physical-therapy', name: 'Physical Therapy', isFilter: true },
  { value: 'political-science', name: 'Political Science', isFilter: true },
  { value: 'product-management', name: 'Product Management', isFilter: true },
  { value: 'project-management', name: 'Project Management', isFilter: true },
  { value: 'psychology', name: 'Psychology', isFilter: true },
  { value: 'public-speaking', name: 'Public Speaking', isFilter: true },
  { value: 'quality-assurance', name: 'Quality Assurance', isFilter: true },
  { value: 'quantum-computing', name: 'Quantum Computing', isFilter: true },
  { value: 'renewable-energy', name: 'Renewable Energy', isFilter: true },
  { value: 'risk-management', name: 'Risk Management', isFilter: true },
  { value: 'robotics', name: 'Robotics', isFilter: true },
  { value: 'sales-strategy', name: 'Sales Strategy', isFilter: true },
  { value: 'seo-optimization', name: 'SEO Optimization', isFilter: true },
  { value: 'social-media-management', name: 'Social Media Management', isFilter: true },
  { value: 'society', name: 'Society', isFilter: true },
  { value: 'software-architecture', name: 'Software Architecture', isFilter: true },
  { value: 'special-education', name: 'Special Education', isFilter: true },
  { value: 'supply-chain-management', name: 'Supply Chain Management', isFilter: true },
  { value: 'sustainable-development', name: 'Sustainable Development', isFilter: true },
  { value: 'talent-acquisition', name: 'Talent Acquisition', isFilter: true },
  { value: 'technical-writing', name: 'Technical Writing', isFilter: true },
  { value: 'translation', name: 'Translation', isFilter: true },
  { value: 'ui-ux-design', name: 'UI/UX Design', isFilter: true },
  { value: 'urban-planning', name: 'Urban Planning', isFilter: true },
  { value: 'video-production', name: 'Video Production', isFilter: true },
  { value: 'virtual-reality', name: 'Virtual Reality', isFilter: true },
  { value: 'web-development', name: 'Web Development', isFilter: true },
  { value: 'other', name: 'Other', isOther: true }
];

export const availableFocusAreas = [
  { value: 'HEALTH_LIVING', name: 'FOCUS_AREA_HEALTH_LIVING' },
  { value: 'SUSTAINABILITY', name: 'FOCUS_AREA_SUSTAINABILITY' },
  { value: 'RESILIENCE', name: 'FOCUS_AREA_RESILIENCE' },
  { value: 'DIGITAL_HEALTH', name: 'FOCUS_AREA_DIGITAL_HEALTH' },
  { value: 'TRANSVERSAL', name: 'FOCUS_AREA_TRANSVERSAL', isOther: true }
];
